import type { TOC } from '@ember/component/template-only'
import RouteTemplate from 'ember-route-template'
import type ProductManageAllStudentsRoute from 'teacher-ui-client/assignments/product/manage/all-students/route'
import type ProductManageAllStudentsController from 'teacher-ui-client/assignments/product/manage/all-students/controller'
import { StudentsTable } from 'teacher-ui-client/components/assignments-admin/students-table/index'

interface Signature {
  Args: {
    model: ModelFor<ProductManageAllStudentsRoute>
    controller: ProductManageAllStudentsController
  }
}
export const AssignmentsManageAllStudentsPage: TOC<Signature> = <template>
  <StudentsTable
    @subscriptionType={{@model.subscriptionType}}
    @students={{@model.students}}
    @assignments={{@model.assignments}}
    @selectedStudent={{@controller.selectedStudent}}
    @goToStudentAction={{@controller.goToStudent}}
    @schoolClasses={{@model.schoolClasses}}
    @selectedSchoolClassId={{@controller.selectedSchoolClassId}}
    @selectSchoolClassIdAction={{@controller.selectSchoolClassId}}
  />
</template>

export default RouteTemplate(AssignmentsManageAllStudentsPage)
